import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';

import DeleteModal from 'components/HTMLElements/DeleteModal';
import AutomaticResponsesBtn from 'routes/app/components/Agent/AutomaticResponsesBtn/';
import ChannelService from 'services/ChannelService'
import { FormGroup, Text, Textarea } from 'components/FormElements/';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { required } from 'constants/InputErrors';

class AddImsModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      options: {},
      submitConfirmationModalOpened: false,
    };

    this.submitForm = this.submitForm.bind( this );
  }

  submitForm() {
    const { channelUid, onClose, onOpenChannel, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    ChannelService.updateChannelStatus( channelUid, {
      ...this.submitData,
      status: 'open'
    } ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) return toggleAlertError( response.errors );

      onOpenChannel( channelUid );
      onClose()
    } )
  }

  toggleSubmitConfirmationModal = ( data ) => {
    this.submitData = data;
    this.setState( { submitConfirmationModalOpened: !this.state.submitConfirmationModalOpened } );
  };

  render() {
    const { onClose, open, options } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="directMessage"/></h5>

        <Form
          onSubmit={this.toggleSubmitConfirmationModal}
          validate={( values ) => {
            return {
              lastComment: required( values.lastComment )
            }
          }}
        >
          {( { getValue, setValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="d-flex justify-content-end">
                <AutomaticResponsesBtn options={options.responses}
                                       onClickResponse={( value ) => setValue( 'lastComment', value )}
                />
              </div>
              <FormGroup>
                <Textarea field="lastComment" className="form-control" rows={8}/>
              </FormGroup>

              <div className="text-right">
                <button className="btn btn-info px-3">
                  <i className="fa fa-send mr-1"/> <Translate id="send"/>
                </button>
              </div>
            </form>
          }
        </Form>

        <DeleteModal label={<Translate id="youSureReplyChannel"/>}
                     onConfirm={this.submitForm}
                     opened={this.state.submitConfirmationModalOpened}
                     onToggle={this.toggleSubmitConfirmationModal}
        />
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  null,
  mapDispatchToProps
)( AddImsModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/DirectMessageModal/index.js